<template>
    <div class="serverPanel"  @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)" @mousemove="mouseMove($event)" ref="serverPanel" @touchstart="touchEnter($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
        <div class="scroll" :style="calcServerWidth(contentServerList.list0, isPcWidth)" ref="serverScroll">
            <div class="one-scroll" :style="calcOneServerWidth(contentServerList.list0, isPcWidth)">
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list0">
                        <div class="item" :key="'item0' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list1">
                        <div class="item" :key="'item1' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list2">
                        <div class="item" :key="'item2' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
            </div>
            <div class="one-scroll" :style="calcOneServerWidth(contentServerList.list0, isPcWidth)">
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list0">
                        <div class="item" :key="'item0' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list1">
                        <div class="item" :key="'item1' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list2">
                        <div class="item" :key="'item2' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
            </div>
            <div class="one-scroll" :style="calcOneServerWidth(contentServerList.list0, isPcWidth)">
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list0">
                        <div class="item" :key="'item0' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list1">
                        <div class="item" :key="'item1' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
                <div class="row-scroll">
                    <template v-for="(item, index) in contentServerList.list2">
                        <div class="item" :key="'item2' + index"><img :src="item.image" alt="item.name" title="item.name" class="img" /></div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isMobile } from '../../../utils/index';
export default {
    components: {

    },
    props: {
        serverList: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            isMobile: isMobile(),
            calcServerWidth: function (list, ispc) {
                if (ispc) {
                    var width = list.length * 3 * 3.20;
                } else {
                    var width = list.length * 3 * 1.25;
                }
                return "width:" + width + "rem";
            },
            calcOneServerWidth: function (list, ispc) {
                if (ispc) {
                    var width = list.length * 3.20;
                } else {
                    var width = list.length * 1.25;
                }
                return "width:" + width + "rem";
            },
            isPcWidth: true,
            contentServerList: {
                list0: [],
                list1: [],
                list2: []
            },
            speed: {
                min: 0,
                max: 10,
                current: 3,
                default: 3,
                turnLeft: true,
            },
        };
    },
    created() {
        // 只取能被3整除的
        var num = this.serverList.length / 3;
        console.log(num);
        var list0 = [];
        var list1 = [];
        var list2 = [];
        for (var i = 0; i < num; i++) {
            list0.push(this.serverList[i]);
            list1.push(this.serverList[i + num]);
            list2.push(this.serverList[i + num * 2]);
        }
        this.contentServerList.list0 = list0;
        this.contentServerList.list1 = list1;
        this.contentServerList.list2 = list2;
    },
    mounted() {
        var that = this;
        this.scrollTimer = setInterval(function () {
            that.moveScroll();
        }, 20);

        this.$(window).on('resize', function () {
            that.resizeWindow();
        });
        that.resizeWindow();
    },
    beforeDestroy() {
        clearInterval(this.scrollTimer);
    },
    methods: {
        resizeWindow() {
            var $ = window.$;
            if ($(window).width() <= 750) {
                this.isPcWidth = false;
            } else {
                this.isPcWidth = true;
            }
            console.log(this.isPcWidth);
        },
        mouseEnter(e) {
            this.mouseMove(e);
            // console.log(e);
        },
        mouseLeave(e) {
            this.speed.current = this.speed.default;
        },
        mouseMove(e) {
            var $ = window.$;
            var x = e.clientX;
            var panel = $(this.$refs['serverPanel']);
            var half = $(panel).width() / 2;
            if (x <= half) {
                // 左边
                this.speed.turnLeft = true;
                var speed = ((half - x) / half) * this.speed.max;
            } else {
                // 右边
                this.speed.turnLeft = false;
                var speed = ((x - half) / half) * this.speed.max;
            }
            this.speed.current = speed;
            // console.log(e);
        },
        touchEnter(e) {
            this.mouseEnter(e.touches[0]);
        },
        touchMove(e) {
            this.mouseMove(e.touches[0]);
        },
        touchEnd(e) {
            this.mouseLeave(e.touches[0]);
        },
        moveScroll() {
            var $ = window.$;
            var el = $(this.$refs['serverScroll']);
            var maxWidth = $(el).width();
            var oneWidth = maxWidth / 3;

            var panel = $(this.$refs['serverPanel']);
            var scrollLeft = $(panel).scrollLeft();
            // console.log(maxWidth, oneWidth, scrollLeft);

            var speed = this.speed.current * (this.isMobile ? 0.5 : 1);
            scrollLeft = scrollLeft + (this.speed.turnLeft ? speed : -speed);

            if (this.speed.turnLeft) {
                if (scrollLeft >= oneWidth * 2) {
                    scrollLeft -= oneWidth;
                }
            } else {
                if (scrollLeft <= oneWidth) {
                    scrollLeft += oneWidth;
                }
            }
            $(panel).scrollLeft(scrollLeft);
            // console.log(scrollLeft);

        },

    },
};
</script>
<style scoped lang="scss" >
.serverPanel {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    height: 4.95rem;

    .scroll {
        width: 15000px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: nowrap;
        justify-items: flex-start;
        align-content: flex-start;

        .one-scroll {
            width: 15000px;
            height: 100%;
        }

        .row-scroll {
            width: 100%;
            height: 1.65rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            flex-wrap: nowrap;
            justify-items: flex-start;
            align-content: flex-start;
        }

        .item {
            border: 1px solid #cacaca;
            width: 3.20rem;
            height: 1.65rem;
            box-sizing: border-box;

            .img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

    }
}

@media screen and (max-width: 750px) {
    .serverPanel {
        height: 1.933rem;

        .scroll {
            .row-scroll {
                height: 0.6445rem;
            }

            .item {
                width: 1.25rem;
                height: 0.6445rem;
                box-sizing: border-box;

                .img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
}
</style>
